import { Button, Tooltip, Typography } from 'antd';
import type { ColumnType, ColumnsType } from 'antd/es/table';
import { EyeOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';

import Table from '../../../../components/general/table';
import { ExportExcelProps } from '../../../../helpers/excel';
import { ExportPdfProps } from '../../../../helpers/pdf';
import { CanShow } from '../../../../components';
import { Contact } from '../../../../api/models/contacts';
import ContactForm from '../detail';
import moment from 'moment';

const label = 'proyecto';
const route = '/projects';
const titlePdf = 'Reporte de proyectos';

type GenerateTableColumnProps = {
  getColumnSearchProps: (propName: string) => ColumnType<Contact>;
  showModal: (type: string, id: number | null) => void;
  handleDelete: (id: number) => void;
};

const ProjectsList = () => {
  const { Text } = Typography;

  const generateTableColumns: (
    props: GenerateTableColumnProps
  ) => ColumnsType<Contact> = (props) => {
    const { getColumnSearchProps, showModal, handleDelete } = props;

    return [
      {
        title: 'Nombre',
        width: 100,
        ellipsis: true,
        dataIndex: 'name',
        key: 'name',
        ...getColumnSearchProps('name'),
        render: (name) => (
          <>
            {name && (
              <Text>{name.charAt(0).toUpperCase() + name.slice(1)}</Text>
            )}
          </>
        ),
      },
      {
        title: 'Cliente',
        width: 100,
        ellipsis: true,
        dataIndex: 'customerName',
        key: 'customerName',
        ...getColumnSearchProps('customerName'),
      },
       {
        title: 'Responsable',
        width: 100,
        ellipsis: true,
        dataIndex: 'responsibleName',
        key: 'responsibleName',
        ...getColumnSearchProps('responsibleName'),
        render: (responsibleName) => (
          <>
            {responsibleName && (
              <Text>{responsibleName.charAt(0).toUpperCase() + responsibleName.slice(1)}</Text>
            )}
          </>
        ),
      },
      {
        title: 'Región',
        width: 100,
        ellipsis: true,
        dataIndex: 'regionName',
        key: 'regionName',
        ...getColumnSearchProps('regionName'),
        render: (regionName) => (
          <>
            {regionName && (
              <Text>{regionName.charAt(0).toUpperCase() + regionName.slice(1)}</Text>
            )}
          </>
        ),
      },
       {
              title: 'Fecha de inicio',
              key: 'startDate',
              width: 100,
              dataIndex: 'startDate',
              render: (startDate) => (
                <>{moment(startDate).format('DD/MM/YYYY')}</>
              ),
            },
            {
              title: 'Fecha de término',
              key: 'endDate',
              width: 100,
              dataIndex: 'endDate',
              render: (endDate) => (
                <>{moment(endDate).format('DD/MM/YYYY')}</>
              ),
            },
            {
        title: 'Fases totales',
        width: 100,
        ellipsis: true,
        dataIndex: 'totalPhases',
        key: 'totalPhases',
        ...getColumnSearchProps('totalPhases'),
      },
       {
        title: 'Fase actual',
        width: 100,
        ellipsis: true,
        dataIndex: 'currentPhase',
        key: 'currentPhase',
        ...getColumnSearchProps('currentPhase'),
      },
      {
        title: 'Estatus',
        width: 100,
        ellipsis: true,
        dataIndex: 'statusDisplayName',
        key: 'statusDisplayName',
        ...getColumnSearchProps('statusDisplayName'),
        render: (statusDisplayName) => (
          <>
            {statusDisplayName && (
              <Text>{statusDisplayName.charAt(0).toUpperCase() + statusDisplayName.slice(1)}</Text>
            )}
          </>
        ),
      },
      {
        title: 'Acciones',
        key: 'sup',
        fixed: 'right',
        width: 100,
        align: 'center',
        render: (contact) => (
          <>
            <Tooltip title="Ver más información">
              <Button
                type="primary"
                ghost
                shape="circle"
                size="small"
                icon={<EyeOutlined />}
                onClick={() => showModal('watch', contact.id)}
              />
            </Tooltip>
            <Tooltip title="Editar">
              <Button
                style={{
                  marginLeft: 10,
                  backgroundColor: '#537896',
                  borderColor: '#537896',
                }}
                type="primary"
                shape="circle"
                size="small"
                icon={<EditOutlined />}
                onClick={() => showModal('edit', contact.id)}
              />
            </Tooltip>
            <Tooltip title="Eliminar">
              <Button
                style={{
                  marginLeft: 10,
                  backgroundColor: '#e63241',
                  borderColor: '#cf1322',
                }}
                type="primary"
                shape="circle"
                size="small"
                icon={<DeleteOutlined />}
                onClick={() => handleDelete(contact.id)}
              />
            </Tooltip>
          </>
        ),
      },
    ];
  };

  const generateExportExcelProps: () => ExportExcelProps = () => ({
    fileName: 'Reporte_Proyectos',
    sheetName: 'Proyectos',
    tableName: 'Tabla de Proyectos',
    columnNames: [
      { label: 'Nombre', key: 'name' },
      { label: 'Cliente', key: 'customerName' },
    ],
  });

  const pdfColumns: ExportPdfProps[] = [
    { header: 'Nombre', key: 'name', width: 50 },
    { header: 'Cliente', key: 'customerName' },
  ];
  const projectsTableProps = {
    label,
    route,
    generateTableColumns,
    generateExportExcelProps,
    detailForm: ContactForm,
    pdfColumns,
    titlePdf,
  };
  const ProjectsTable = Table<Contact>(projectsTableProps);

  return ProjectsTable;
};

export default ProjectsList;
